// src/pages/HomePage.jsx
import React, { useState, useEffect } from "react";
import { useLocale } from "../contexts/LocaleContext";
import { getHomePageData } from "../api/apiService";

import {
  HeroBanner,
  // ImageGallery,
  FeaturedProducts,
  BottomSection,
} from "../components/home";
import ScrollReveal from "../components/common/ScrollReveal";

// Base URL for media assets - adjust based on your Strapi configuration
const MEDIA_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:1337";

/** Full-bleed mist/lake bands (no rounded ?�card??chrome); content width only where needed */
const HOME_CONTENT = "max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-10";

const DEFAULT_SITE_TITLE = "CAS Systems";

const HomePage = () => {
  const { locale } = useLocale();
  const [homeData, setHomeData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = DEFAULT_SITE_TITLE;
  }, []);

  useEffect(() => {
    const fetchHomeData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await getHomePageData(locale);
        setHomeData(data);
      } catch (err) {
        console.error("Error fetching homepage data:", err);
        setError(err.message || "Failed to load homepage data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchHomeData();
  }, [locale]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center page-canvas">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-lake-400 mx-auto mb-4" />
          <p className="text-brand-foreground/80">Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center page-canvas">
        <div className="text-center text-red-600">
          <p className="text-xl font-semibold mb-2">Error</p>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!homeData) {
    return (
      <div className="min-h-screen flex items-center justify-center page-canvas">
        <p className="text-brand-foreground/80">No data available</p>
      </div>
    );
  }

  const {
    banner,
    imgs,
    products,
    productsTitle,
    news,
    lastestNewsTitle,
    moreNewsBtnText,
    bottom,
  } = homeData;

  return (
    <div className="homepage min-h-full">
      {/* Hero ??white band */}
      <ScrollReveal className="homepage-fade-up homepage-fade-up--1 block w-full section-surface-white py-5 sm:py-8">
        <HeroBanner banner={banner} mobileImages={imgs} />
      </ScrollReveal>

      {/* Image gallery: softer band, uneven vertical rhythm */}
      {/* <ScrollReveal className="homepage-fade-up homepage-fade-up--2 block w-full section-surface-lake py-9 sm:py-14">
        <div className={HOME_CONTENT}>
          <ImageGallery images={imgs} />
        </div>
      </ScrollReveal> */}

      {/* Featured products */}
      <ScrollReveal className="homepage-fade-up homepage-fade-up--3 block w-full section-surface-brand py-8 sm:py-11">
        <div className={HOME_CONTENT}>
          <FeaturedProducts
            products={products}
            title={productsTitle}
          />
        </div>
      </ScrollReveal>

      {/* News + media */}
      <ScrollReveal className="homepage-fade-up homepage-fade-up--4 block w-full section-surface-mist py-10 sm:py-16 pb-14 sm:pb-20">
        <div className={HOME_CONTENT}>
          <BottomSection
            bottomItems={bottom}
            news={news[0].list}
            newsTitle={lastestNewsTitle}
            moreNewsBtnText={moreNewsBtnText}
            baseUrl={MEDIA_BASE_URL}
          />
        </div>
      </ScrollReveal>
    </div>
  );
};

export default HomePage;

